import { inject, observer } from "mobx-react";
import { Helmet } from "react-helmet-async";

import { renderMetaTags } from "../../../server/middleware/interpretTags";
import type { Store } from "../../../client/stores";

export interface MetaTagsProps {
  store?: Store;
}

export const MetaTags = inject("store")(
  observer(({ store }: MetaTagsProps) => {
    if (!store) {
      return null;
    }

    return <Helmet>{renderMetaTags(store.tags.metadata)}</Helmet>;
  }),
);

export default MetaTags;
